"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const LANG = {
    EN: 'en',
    AR: 'ar',
};
exports.default = LANG;
